import { usePortalSize } from "@src/Components/Common/usePortalSize"
import { Section } from "@src/Components/StyledUtils"
import * as React from "react"

import { Description, SubHeading } from "../../styles"
import { StyledUl } from "../styles"

export const EmptyStateCard = () => {
  const { isLargeScreen } = usePortalSize()

  return (
    <>
      <SubHeading maxWidth={isLargeScreen ? "400px" : undefined}>
        Talk with an expert about your cybersecurity needs.
      </SubHeading>
      <Description>
        <Section flex={isLargeScreen && "center"} align="left">
          <StyledUl>
            <li>Get live help from a trusted advisor.</li>
            <li>Discover and fix security weaknesses.</li>
          </StyledUl>
        </Section>
      </Description>
    </>
  )
}
